
<template>
<div>
  <chc-header :noLogin="true"></chc-header>
  <navbar :noLogin="true"></navbar>
  <section class="login-wrapper">

    <!-- Log In -->
    <form @submit.prevent>
      <section v-if="state === 'login'">
        <div class="field">
          <h1>Login</h1>
        </div>
        <chc-input v-on:enter="login" v-model="user.email" type="email" label="Email" :required="true" ref="loginEmail"></chc-input>
        <chc-input v-on:enter="login" v-model="user.password" type="password" label="Password" :required="true" ref="loginPassword"></chc-input>
        <div class="field"><span class="error-message">{{ loginPage.loginError }}</span></div>
        <div class="field buttons">
          <input type="submit" class="btn" @click="login" v-bind:value="loginPage.processing ? 'Processing...' : 'Continue'">
          <a class="secondary-action" v-on:click="forgotPasswordTrigger">Forgot Password?</a>
        </div>
      </section>
    </form>

    <section v-if="state === 'loginTwoFactor'">
      <div class="field">
        <h1>Verification Code</h1>
        <p>A verification code has been sent via text message. Please enter it below.</p>
      </div>
      <chc-input v-on:enter="loginTwoFactor" v-model="user.secret" type="text" label="Verification Code" :error="loginTwoFactorPage.loginError" ref="loginSecret"></chc-input>
      <div class="field buttons">
        <input type="submit" class="btn" :value="loginTwoFactorPage.processing ? 'Processing...' : 'Continue'"
               @click="loginTwoFactor">
        <a class="secondary-action">Resend Verification Code</a>
      </div>
    </section>

    <!-- Forgot Password -->
    <section v-if="state === 'forgotPassword'">
      <div class="field">
        <h1>Forgot Password</h1>
        <p>Enter your email address and a verification code will be sent via text message to your mobile phone on file.</p>
      </div>
      <chc-input v-on:enter="requestPasswordReset" v-model="user.email" type="email" label="Email" :required="true" ref="forgotPasswordEmail"></chc-input>
      <div v-if="forgotPassword.forgotError.errors && forgotPassword.forgotError.errors.email" class="field"><span class="error-message">Invalid Email</span></div>
      <div v-if="forgotPassword.forgotError.user" class="field"><span class="error-message">No account exists for this email</span></div>
      <div class="field buttons">
        <input class="btn" @click="requestPasswordReset" value="Request Password Reset" type="submit">
        <a class="secondary-action" @click="backToLogin">Back</a>
      </div>
    </section>

    <section v-if="state === 'resetPasswordCode'">
      <div class="field">
        <h1>Verification Code</h1>
        <p>A verification code has been sent via text message. Please enter it below.</p>
      </div>
      <div class="field">
        <chc-input v-on:enter="resetPasswordState" v-model="user.secret" label="Verification Code" ref="forgotPasswordSecret"></chc-input>
      </div>
       <div v-if="forgotPassword.forgotError.error" class="field"><span class="error-message">{{ forgotPassword.forgotError.error }}</span></div>
      <div class="field buttons">
        <input type="submit" class="btn" value="Continue"
               @click="resetPasswordState">
        <a @click="requestPasswordReset" class="secondary-action">Resend Verification Code</a>
      </div>
    </section>

    <!-- Reset Password -->
    <section v-if="state === 'resetPassword'">
      <div class="field">
        <h1>Password</h1>
      </div>
      <chc-input v-on:enter="resetPassword" v-model="forgotPassword.password" label="Password" :required="true" type="password" :error="forgotPassword.forgotError.password"></chc-input>
      <chc-input v-on:enter="resetPassword" v-model="forgotPassword.password_confirmation" label="Password Confirm" :required="true" type="password" :error="forgotPassword.forgotError.password_confirmation"></chc-input>
      <div class="field buttons">
        <input class="btn" value="Save" @click="resetPassword" type="submit">
      </div>
    </section>
  </section>
</div>
</template>

<script>
import auth from '@/auth'
import ChcHeader from '@/components/ChcHeader'
import Navbar from '@/components/Navbar'

export default {
  name: 'Login',
  data () {
    return {
      // login loginTwoFactor forgotPassword
      state: 'login',
      user: {
        email: null,
        password: null,
        secret: null
      },
      loginPage: {
        loginError: null,
        processing: false
      },
      loginTwoFactorPage: {
        loginError: null,
        processing: false
      },
      forgotPassword: {
        forgotError: {},
        secret: null,
        secretConfirm: null,
      }
    }
  },
  methods: {
    login () {
      // Chrome autofill from password manager doesn't send browser events, so vue is out of sync
      // check the ref values.
      if (this.$refs.loginEmail.valueData !== this.user.email) {
        this.user.email = this.$refs.loginEmail.valueData
      }
      if (this.$refs.loginPassword.valueData !== this.user.password) {
        this.user.password = this.$refs.loginPassword.valueData
      }
      this.loginPage.processing = true
      auth.login(this, this.user, () => {
        this.$router.push({name: 'App'})
      }, (resp) => {
        if (resp.response.data.needMobilePhone) {
          this.loginPage.loginError = 'This account does not have a mobile phone associated with it. We are unable to send a verification code. Please contact a CHC Admin to fix the account'
          this.loginPage.processing = false
        } else if (resp.response.data.needTwoFactor) {
          this.state = 'loginTwoFactor'
          this.user.secret = ''
        } else {
          this.loginPage.loginError = 'Username or email not valid'
          this.loginPage.processing = false
        }
      })
    },
    loginTwoFactor () {
      this.loginTwoFactorPage.processing = true
      auth.loginTwoFactor(this, this.user, () => {
        this.$router.push({name: 'App'})
      }, (resp) => {
        this.loginTwoFactorPage.loginError = ['Two factor code not valid.']
        this.loginTwoFactorPage.processing = false
      })
    },
    forgotPasswordTrigger () {
      this.user.email = null
      this.user.password = null
      this.user.secret = null
      this.state = 'forgotPassword'
      this.$nextTick(() => {
        this.$refs.forgotPasswordEmail && this.$refs.forgotPasswordEmail.forceUpdateValue(null)
        this.$refs.forgotPasswordSecret && this.$refs.forgotPasswordSecret.forceUpdateValue(null)
      })
    },
    backToLogin () {
      this.user.email = null
      this.user.password = null
      this.user.secret = null
      this.state = 'login'
      this.$nextTick(() => {
        this.$refs.forgotPasswordEmail && this.$refs.forgotPasswordEmail.forceUpdateValue(null)
        this.$refs.loginEmail && this.$refs.loginEmail.forceUpdateValue(null)
        this.$refs.loginPassword && this.$refs.loginPassword.forceUpdateValue(null)
      })
    },
    requestPasswordReset () {
      auth.sendVerificationCode(this.user, () => {
        this.user.secret = null
        this.state = 'resetPasswordCode'
        this.$nextTick(() => {
          this.$refs.forgotPasswordSecret && this.$refs.forgotPasswordSecret.forceUpdateValue(null)
          this.$refs.loginSecret && this.$refs.loginSecret.forceUpdateValue(null)
        })
      }, (resp) => {
        this.forgotPassword.forgotError = resp.response.data
      })
    },
    resetPasswordState () {
      auth.validateVerificationCode(this.user, () => {
        this.state = 'resetPassword'
      }, (resp) => {
        this.forgotPassword.forgotError = resp.response.data
      })
    },
    resetPassword () {
      let self = this
      auth.forgotPassword(this, {
        email: this.user.email,
        secret: this.user.secret,
        password: this.forgotPassword.password,
        password_confirmation: this.forgotPassword.password_confirmation
      }, () => {
        this.forgotPassword.forgotError = {}
        this.user.email = null
        this.user.password = null
        this.user.secret = null
        this.state = 'login'
        this.$nextTick(() => {
          this.$refs.forgotPasswordEmail && this.$refs.forgotPasswordEmail.forceUpdateValue(null)
          this.$refs.loginEmail && this.$refs.loginEmail.forceUpdateValue(null)
          this.$refs.loginPassword && this.$refs.loginPassword.forceUpdateValue(null)
          this.$refs.loginSecret && this.$refs.loginSecret.forceUpdateValue(null)
          this.$refs.forgotPasswordSecret && this.$refs.forgotPasswordSecret.forceUpdateValue(null)
        })
      }, (resp) => {
        self.forgotPassword.forgotError = resp.response.data.errors
        if (self.forgotPassword.forgotError === 'Unauthorized') {
          self.state = 'resetPasswordCode'
          self.user.secret = null
          self.user.password = null
          self.user.password_confirmation = null
        }
      })
    },
  },
  components: {
    ChcHeader,
    Navbar
  }
}
</script>

<style lang="scss">
@import "../../style/variables";

.login-wrapper {
  padding-top: 4rem;
  .field {
    h1 {
      margin: 0;
    }
    p {
      margin: 1em 0;
    }
  }
  .field.buttons {
    margin-top: 2rem;
  }
  .secondary-action {
    font-weight: normal;
    font-size: .875rem;
  }
  h2 {
    text-transform: none;
    margin-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Login/Login.vue